import React, { useEffect, useState } from 'react';
import { Alert, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import LeavePolicyForm from './LeavePolicyForm';
import axiosInstance from '../utills/axiosInstance';
import { usePermissions } from '../utills/usePermissions';

const LeavePolicy = () => {
    const [policies, setPolicies] = useState([]);
    const [openForm, setOpenForm] = useState(false);
    const [editingPolicy, setEditingPolicy] = useState(null);

    const { canView, canEdit, canCreate } = usePermissions();

    useEffect(() => {
        fetchPolicies();
    }, []);

    const fetchPolicies = async () => {
        const res = await axiosInstance.get('/api/leave/types');
        setPolicies(res?.data);
    };

    const handleSave = async (policyData) => {
        if (editingPolicy) {
            await axiosInstance.put(`/api/leave/types/${editingPolicy._id}`, policyData);
        } else {
            await axiosInstance.post('/api/leave/types', policyData);
        }
        setOpenForm(false);
        fetchPolicies();
    };

    if(!canView('leavePolicy')){
        return(
            <Alert severity='warning'>Insufficient permissions to view Leave Policy.</Alert>
        )
    }

    return (
        <Paper sx={{ p: 2, m: 2 }}>

            {
                canCreate('leavePolicy') && (
                    <Button variant="contained" onClick={() => { setOpenForm(true); setEditingPolicy(null); }}>Add Policy</Button>
                )
            }

            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Code</TableCell>
                            <TableCell>Type</TableCell>
                            <TableCell>Credits/Cycle</TableCell>
                            <TableCell>Carry Forward Max</TableCell>
                            {
                                canEdit('leavePolicy') && (
                                    <TableCell>Actions</TableCell>
                                )
                            }
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {policies?.map((policy) => (
                            <TableRow key={policy._id}>
                                <TableCell>{policy.name}</TableCell>
                                <TableCell>{policy.code}</TableCell>
                                <TableCell>{policy.type}</TableCell>
                                <TableCell>{policy.creditsPerCycle}</TableCell>
                                <TableCell>{policy.carryForward?.maxDays || 'N/A'}</TableCell>
                                <TableCell>
                                    {
                                        canEdit('leavePolicy') && (
                                            <Button onClick={() => { setEditingPolicy(policy); setOpenForm(true); }}>Edit</Button>
                                        )
                                    }
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <LeavePolicyForm open={openForm} onClose={() => setOpenForm(false)} onSave={handleSave} editing={editingPolicy} />
        </Paper>
    );
};

export default LeavePolicy;
